export const profileTabs = [
  {
    id: 1,
    label: "Профіль",
  },
  {
    id: 2,
    label: "Історія",
  },
  {
    id: 3,
    label: "Налаштування",
  },
];

export const tabValues = {
  mainInfo: 0,
  history: 1,
  settings: 2,
};
